import Dialog from "@material-ui/core/Dialog";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import RadioButtonUncheckedIcon from "@material-ui/icons/RadioButtonUnchecked";
import Timeline from "@material-ui/lab/Timeline";
import TimelineConnector from "@material-ui/lab/TimelineConnector";
import TimelineContent from "@material-ui/lab/TimelineContent";
import TimelineItem from "@material-ui/lab/TimelineItem";
import TimelineSeparator from "@material-ui/lab/TimelineSeparator";
import _ from "lodash";
import moment from "moment";
import { Component } from "react";
import { ProgressBar, Step } from "react-step-progress-bar";
import locales from "../_constants/locales";
import StyledButtonCancel from "./StyledButtonCancel.jsx";
import "./styles/StatusProgressBar.css";

class StatusProgressBar extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isDetailedViewOpen: false
        };
    }

    handleStatusBarClick(e) {
        this.setState({
            isDetailedViewOpen: true
        });
    }

    handleDetailedViewClose() {
        this.setState({
            isDetailedViewOpen: false
        });
    }

    getLogStatusTitle(code) {
        if (locales[this.props.language.code].TICKET.REQUEST_DETAILS.STATUS[code]) {
            return locales[this.props.language.code].TICKET.REQUEST_DETAILS.STATUS[code].TITLE;
        } else {
            return code;
        }
    }

    getLogStatusDescription(code) {
        if (locales[this.props.language.code].TICKET.REQUEST_DETAILS.STATUS[code]) {
            return locales[this.props.language.code].TICKET.REQUEST_DETAILS.STATUS[code].DESCRIPTION;
        } else {
            return code;
        }
    }

    getCurrentLogStatusCode() {
        let milestoneRequestLogs = this.props.request.requestLogs.filter(requestLog => requestLog.milestone === true);
        let currentMilestoneRequestLog = milestoneRequestLogs.filter(requestLog => requestLog.current === true)[0];

        if (currentMilestoneRequestLog) {
            return currentMilestoneRequestLog.status.code;
        } else {
            return null;
        }
    }

    showCurrentStatusDescription() {
        let milestoneRequestLogs = this.props.request.requestLogs.filter(requestLog => requestLog.milestone === true);
        let currentMilestoneRequestLog = milestoneRequestLogs.filter(requestLog => requestLog.current === true)[0];

        if (currentMilestoneRequestLog && milestoneRequestLogs.some(rl => rl.index > currentMilestoneRequestLog.index)) {
            return true;
        } else {
            return false;
        }
    }

    render() {
        var completedPercentage = 0;
        var milestoneRequestLogs = this.props.request.requestLogs.filter(requestLog => requestLog.milestone === true);
        var numberOfMilestoneRequestLogs = milestoneRequestLogs.length;
        var completedMilestoneRequestLogs = milestoneRequestLogs.filter(requestLog => requestLog.date !== null);

        if (numberOfMilestoneRequestLogs === completedMilestoneRequestLogs.length) {
            completedPercentage = 100;
        } else {
            var percentPerMilestoneRequestLog = 100 / (numberOfMilestoneRequestLogs - 1);
            completedPercentage = completedMilestoneRequestLogs.length * percentPerMilestoneRequestLog - percentPerMilestoneRequestLog * 0.25;
        }

        return (
            <div className="layout vertical">
                <button
                    className="flex progress-bar-box clickable"
                    onClick={this.handleStatusBarClick.bind(this)}
                    aria-label={locales[this.props.language.code].TICKET.REQUEST_DETAILS.TIMELINE.TITLE}
                >
                    <div className="status-bar">
                        <Timeline className="timeline-vertical">
                            {_.orderBy(milestoneRequestLogs, "date", "asc").map((requestLog, i) => {
                                let accomplished = requestLog.date !== null;
                                let ariaLabel = `${this.getLogStatusTitle(requestLog.status.code)} (${
                                    accomplished
                                        ? locales[this.props.language.code].TICKET.REQUEST_DETAILS.STATUS.REACHED
                                        : locales[this.props.language.code].TICKET.REQUEST_DETAILS.STATUS.UNREACHED
                                })`;

                                let connectorClassName = "";

                                if (i + 1 < milestoneRequestLogs.length) {
                                    connectorClassName = `timeline-connector${milestoneRequestLogs[i + 1].date !== null ? " accomplished" : ""}${
                                        milestoneRequestLogs[i].date && milestoneRequestLogs[i + 1].date === null ? " current" : ""
                                    }`;
                                }

                                let timelineItemLabelClassName = `timeline-item-label${accomplished ? " accomplished" : ""}`;

                                return (
                                    <TimelineItem key={i} className="timeline-item">
                                        <TimelineSeparator>
                                            {requestLog.date !== null ? (
                                                <CheckCircleIcon className={`timeline-step-icon accomplished`} />
                                            ) : (
                                                <RadioButtonUncheckedIcon className="timeline-step-icon" />
                                            )}
                                            {i + 1 < milestoneRequestLogs.length && <TimelineConnector className={connectorClassName} />}
                                        </TimelineSeparator>
                                        <TimelineContent className="timeline-item-content">
                                            <div className="flex layout vertical">
                                                <p className={timelineItemLabelClassName} aria-label={ariaLabel}>
                                                    {this.getLogStatusTitle(requestLog.status.code)}
                                                </p>
                                            </div>
                                        </TimelineContent>
                                    </TimelineItem>
                                );
                            })}
                        </Timeline>
                        <div className="progress-bar">
                            <ProgressBar percent={completedPercentage}>
                                {_.orderBy(milestoneRequestLogs, "date", "asc").map((requestLog, i) => (
                                    <Step key={i}>
                                        {({ accomplished, index }) => {
                                            let ariaLabel = `${this.getLogStatusTitle(requestLog.status.code)} (${
                                                accomplished
                                                    ? locales[this.props.language.code].TICKET.REQUEST_DETAILS.STATUS.REACHED
                                                    : locales[this.props.language.code].TICKET.REQUEST_DETAILS.STATUS.UNREACHED
                                            })`;

                                            let timelineStepLabelClassName = `timeline-step-label${accomplished ? " accomplished" : ""}`;

                                            return (
                                                <div key={i} className="layout vertical center" style={{ position: "relative" }}>
                                                    {accomplished ? (
                                                        <CheckCircleIcon
                                                            className={`timeline-step-icon${accomplished ? " accomplished" : ""}${
                                                                requestLog.current ? " current" : ""
                                                            }`}
                                                        />
                                                    ) : (
                                                        <RadioButtonUncheckedIcon className="timeline-step-icon" />
                                                    )}
                                                    <p aria-label={ariaLabel} className={timelineStepLabelClassName}>
                                                        {this.getLogStatusTitle(requestLog.status.code)}
                                                    </p>
                                                </div>
                                            );
                                        }}
                                    </Step>
                                ))}
                            </ProgressBar>
                        </div>
                    </div>
                </button>
                {this.showCurrentStatusDescription() && this.getCurrentLogStatusCode() && (
                    <div className="flex layout horizontal current-status-description">
                        <div className="pulsating-circle" />
                        <p>
                            {
                                locales[this.props.language.code].TICKET.REQUEST_DETAILS.STATUS.CURRENT_STATUS_DESCRIPTION[this.props.request.requestType.code][
                                    this.getCurrentLogStatusCode()
                                ]
                            }
                        </p>
                    </div>
                )}
                <Dialog open={this.state.isDetailedViewOpen} className="status-bar-detail-dialog" onClose={this.handleDetailedViewClose.bind(this)}>
                    <div className="flex layout vertical scroll detailed-timeline-window">
                        <div className="flex layout vertical detailed-timeline section inner">
                            <header className="section-header">
                                <div className="layout horizontal center title-row">
                                    <h2 className="title flex">{locales[this.props.language.code].TICKET.REQUEST_DETAILS.TIMELINE.TITLE}</h2>
                                </div>
                            </header>
                            <div className="flex layout vertical">
                                <Timeline className="timeline-vertical-detailed">
                                    {_.orderBy(this.props.request.requestLogs, "date", "asc").map((requestLog, i) => {
                                        let accomplished = requestLog.date !== null;
                                        let ariaLabel = `${this.getLogStatusTitle(requestLog.status.code)} (${
                                            accomplished
                                                ? locales[this.props.language.code].TICKET.REQUEST_DETAILS.STATUS.REACHED
                                                : locales[this.props.language.code].TICKET.REQUEST_DETAILS.STATUS.UNREACHED
                                        })`;

                                        let connectorClassName = "";

                                        if (i + 1 < this.props.request.requestLogs.length) {
                                            connectorClassName = `timeline-connector${
                                                this.props.request.requestLogs[i + 1].date !== null ? " accomplished" : ""
                                            }${
                                                this.props.request.requestLogs[i].date && this.props.request.requestLogs[i + 1].date === null ? " current" : ""
                                            }`;
                                        }

                                        return (
                                            <TimelineItem key={i} className="timeline-item">
                                                <TimelineSeparator>
                                                    {requestLog.date !== null ? (
                                                        <CheckCircleIcon className={`timeline-step-icon accomplished`} />
                                                    ) : (
                                                        <RadioButtonUncheckedIcon className="timeline-step-icon" />
                                                    )}
                                                    {i + 1 < this.props.request.requestLogs.length && (
                                                        <TimelineConnector className={connectorClassName} style={{ backgroundColor: "bf0000" }} />
                                                    )}
                                                </TimelineSeparator>
                                                <TimelineContent className="timeline-item-content">
                                                    <div className="flex layout vertical timeline-item-body">
                                                        <div className="timeline-item-header">
                                                            <p className="timeline-item-label" aria-label={ariaLabel}>
                                                                {this.getLogStatusTitle(requestLog.status.code)}
                                                            </p>
                                                            {requestLog.date !== null && (
                                                                <p className="timeline-item-date">
                                                                    {moment(new Date(requestLog.date))
                                                                        .locale(this.props.language.code.toLowerCase())
                                                                        .format("lll")}
                                                                </p>
                                                            )}
                                                        </div>
                                                        <p className="timeline-item-description" title={this.getLogStatusDescription(requestLog.status.code)}>
                                                            {this.getLogStatusDescription(requestLog.status.code)}
                                                        </p>
                                                    </div>
                                                </TimelineContent>
                                            </TimelineItem>
                                        );
                                    })}
                                </Timeline>
                            </div>
                        </div>
                        <div className="footer layout horizontal end-justified">
                            <StyledButtonCancel onClick={this.handleDetailedViewClose.bind(this)} variant="contained">
                                {locales[this.props.language.code].BUTTON.CLOSE.LABEL}
                            </StyledButtonCancel>
                        </div>
                    </div>
                </Dialog>
            </div>
        );
    }
}

export default StatusProgressBar;
